<template>
  <v-card
    max-width="480px"
    class="mx-auto px-5 py-2 my-5"
    justify="center"
    align="center"
  >
    <h2>Thank you!</h2>
    <v-card-subtitle>
      Your message was sent successfully. <br />
      We'll get back to you as soon as possible.
    </v-card-subtitle>

    <v-btn text to="/">Back to Home</v-btn>
  </v-card>
</template>

<script>
export default {
  name: "ContactSuccess",
  data: () => ({}),
};
</script>

<style></style>
